<template>
  <mdb-container>
    <Errors v-if="!!error" :error="error" />
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>

    <mdb-alert
      color="dark"
      v-if="message"
      @closeAlert="message = false"
      dismiss
    >
      {{ message }}
    </mdb-alert>

    <form @submit.prevent="createUser">
      <mdb-col col="12" class="pb-2 justify-content-md-center">
        <mdb-row>
          <mdb-col col="4">
            <mdb-select
              required
              search
              v-model="roles"
              placeholder="Select Role"
              @getValue="setUserRole"
            />
          </mdb-col>
          <mdb-col col="4" v-if="checkRole">
            <mdb-select
              required
              search
              v-model="stations"
              placeholder="Select Station"
              @getValue="setUserStation"
            />
          </mdb-col>

          <mdb-col col="4">
            <mdb-input label="Email" v-model="userInfo.email" required />
          </mdb-col>
          <mdb-col col="4">
            <mdb-input
              label="Password"
              v-model="userInfo.password"
              type="password"
              required
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-input
              label="Confirm Password"
              v-model="userInfo.password_confirmation"
              type="password"
              required
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              :disabled="!isDisabled"
              outline="primary"
              type="submit"
              :icon="btnInfo.btnIcon"
              >{{ btnInfo.btnName }}</mdb-btn
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </form>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbRow,
  mdbCol,
  mdbContainer,
  mdbBtn,
  mdbAlert,
  mdbInput,
  mdbSelect,
} from "mdbvue";

export default {
  components: {
    Errors,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbBtn,
    mdbAlert,
    Spinner,
    mdbInput,
    mdbSelect,
  },

  data() {
    return {
      userInfo: {},
      error: "",
      roles: [],
      stations: [],
      btnInfo: {},
      isLoading: true,
      message: "",
    };
  },
  methods: {
    newUser() {
      return {
        email: "",
        password: "",
        password_confirmation: "",
        station_id: "",
        role: "",
      };
    },

    createUser() {
      api
        .createUser(this.userInfo)
        .then((response) => {
          this.$emit("user-created", response.data);
          this.reset();
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },

    userRoles() {
      return [
        { text: "Admin", value: "admin" },
        { text: "Station Account", value: "station_agent" },
      ];
    },

    setStationList() {
      api
        .getStationList()
        .then((response) => {
          response.data.forEach((station) => {
            this.stations.push({
              text: `${station.location} - ${station.scan_state}`,
              value: station.id,
              selected: false,
            });
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },

    reset() {
      this.userInfo = this.newUser();
      this.errors = {};
    },

    setUserRole(val) {
      this.reset();
      this.userInfo.role = val;
    },

    setUserStation(val) {
      this.userInfo.station_id = val;
    },

    setBtnInfo() {
      return { btnName: "Create User", btnIcon: "plus" };
    },
    validInput() {
      return this.roles.includes(this.userInfo.role);
    },
  },

  created() {
    this.userInfo = this.newUser();
    this.roles = this.userRoles();
    this.setStationList();
    this.btnInfo = this.setBtnInfo();
    this.isLoading = false;
  },
  mounted() {},
  computed: {
    showSpinner() {
      return this.isLoading;
    },

    checkRole() {
      return this.userInfo.role === "station_agent";
    },

    isDisabled() {
      return (
        !!this.userInfo.email &&
        !!this.userInfo.password &&
        !!this.userInfo.password_confirmation &&
        !!this.userInfo.role
      );
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  color: $black-accent-color;
  border-color: $black-accent-color;
  text-transform: uppercase;

  &:hover {
    background-color: $green-accent-color;
    color: white;
  }
}
</style>
